export interface IconProps {
  size?: number;
  stroke?: string;
  strokeWidth?: number;
  className?: string;
}

const MoveVerticalIcon = ({
  size = 16,
  stroke = 'currentColor',
  strokeWidth = 3,
  className,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M12 2v20" />
    <path d="m8 18 4 4 4-4" />
    <path d="m8 6 4-4 4 4" />
  </svg>
);

export default MoveVerticalIcon;
